/**
 * Touch devices never fire hover, so anything revealed only by `:hover` is
 * unreachable there — not degraded, absent. The client reviews this app on
 * mobile-web, which is exactly that case.
 *
 * These are complete literal class strings rather than a composable prefix on
 * purpose: Tailwind's scanner matches whole class names in source, so
 * `` `${PREFIX}:opacity-0` `` would never be generated.
 *
 * The condition is `(min-width: 48rem) and (hover: hover)` rather than a
 * breakpoint alone so a hover-less tablet at >= md is still covered, and it is
 * one flat media query rather than two stacked variants so what compiles is
 * predictable.
 */

/** A hover-only affordance (an info icon): shown only where hover exists. */
export const HOVER_AFFORDANCE_ONLY = "hidden [@media(min-width:48rem)_and_(hover:hover)]:block";

/** Its touch counterpart — the same content, rendered inline instead. */
export const TOUCH_INLINE_FALLBACK = "[@media(min-width:48rem)_and_(hover:hover)]:hidden";

/**
 * A control that desktop reveals on row hover. Visible at rest everywhere
 * hover does not exist, so it stays discoverable on a phone.
 *
 * Deliberately carries no base `opacity-100`: an element's default opacity is
 * already 1, and adding the utility puts an equal-specificity rule in the
 * cascade that beat the media-query `opacity-0` depending on emit order — the
 * control then stayed visible on desktop too, which is a different bug.
 */
export const REVEAL_ON_HOVER =
  "[@media(min-width:48rem)_and_(hover:hover)]:opacity-0 [@media(min-width:48rem)_and_(hover:hover)]:group-hover:opacity-100";
